import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_page-hide_brand_undo-action_unknown';
/**
 * Event is fired when retailer chooses to unhide a brand from a brand page
 */
export function trackBrandPageHideBrandUndo(brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandToken },
    });
}
